/**
 * イベント委譲の統一初期化スクリプト
 *
 * このファイルをアプリケーション起動時に実行すると、
 * すべてのクリックイベントが一箇所で管理されます。
 *
 * 使用例（main.js または common.js）:
 * =========================================
 * import { initEventDelegation } from '@/init/initEventDelegation';
 *
 * // Vue アプリ起動後に実行
 * app.mount('#app');
 * initEventDelegation();
 * =========================================
 */

import { initUnifiedClickHandler, registerClickHandler } from '@/js/utils/eventDelegation';
import { registerScrollHandler } from '@/js/behaviors/scrollBehavior';
import { registerModalHandler } from '@/js/vue/modal';

/**
 * すべてのイベント委譲を初期化
 *
 * ファイル名と関数名を統一: initEventDelegation
 */
export function initEventDelegation(addCustomHandler) {
    // 1. 統一クリックハンドラを初期化
    initUnifiedClickHandler(document);

    // 2. 各機能のハンドラを登録
    registerScrollHandler();    // スクロール（優先度: 10）
    registerModalHandler();     // モーダル（優先度: 5）

    // 3. 追加の機能がある場合はここに登録
    // registerMyCustomHandler();
    if (addCustomHandler && typeof addCustomHandler === 'function') {
        addCustomHandler();
    }

    console.debug('[EventDelegation] Initialized - Click handlers unified');
}

/**
 * 新しいハンドラを動的に追加
 *
 * @param {string} selector - 対象セレクタ（例: '[data-custom]'）
 * @param {function} callback - コールバック関数 (element, event) => void
 * @param {number} [priority=0] - 実行優先度
 *
 * @example
 * addClickHandler('[data-my-button]', (el, event) => {
 *     console.log('Clicked!', el);
 * }, 8);
 */
export function addClickHandler(selector, callback, priority = 0) {
    registerClickHandler({
        selector,
        callback,
        priority,
    });

    console.debug(`[EventDelegation] Added handler for: ${selector}`);
}

